// extracted by mini-css-extract-plugin
module.exports = {"groceryToolbar":"PageGrocery_groceryToolbar__UPxCD","servingsSelector":"PageGrocery_servingsSelector__2t7aM","listHeader":"PageGrocery_listHeader__2NmAb"};